<template>
    <div :class="`summary-content ${isLoading ? 'full-height' : 'more-height'}`">
        <Pagination
            ref="summaryPagination"
            entity="Employees Summary"
            classes="pagination-footer"
            :pageSize="pageSize"
            :pageChanged="pageChanged"
            :showPageSizeOptions="false"
        >
            <section class="pagination-main bg-white">
                <div
                    class="w-100 h-100 py-5 d-flex flex-column align-items-center justify-content-center flex-grow-1"
                    v-if="isLoading"
                >
                    <i class="fas fa-calendar-alt fa-7x animate-flash mb-3"></i>
                    <h4>Loading Employee Summary...</h4>
                </div>
                <template v-if="!hasData || isError">
                    <div
                        class="w-100 h-100 py-5 d-flex flex-column align-items-center justify-content-center flex-grow-1"
                        v-if="!hasData && !isLoading"
                    >
                        <span class="font-size-3xl"> No Data Found. </span>
                    </div>
                    <div
                        class="w-100 h-100 py-5 d-flex flex-column align-items-center justify-content-center flex-grow-1"
                        v-if="isError"
                    >
                        <p>There was an error while fetching the employee summary.<br />Please try again.</p>
                        <button class="btn btn-primary btn-sm" @click="pageReset()">Try Again</button>
                    </div>
                </template>
                <table class="table table-responsive-md border border-gray" v-if="!isError && !isLoading && hasData">
                    <thead>
                        <tr class="bg-table-header table-header">
                            <th class="emp_col">Employee Name</th>
                            <th v-for="header in tableHeaders">{{ header }}</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody v-for="summary in employeeSummary" :key="summary.id">
                        <SummaryViewRow :summary="summary" :columns="columns" v-on:calendarRefresh="pageReset" />
                    </tbody>
                </table>
            </section>
        </Pagination>
    </div>
</template>

<style src="./SummaryView.scss"></style>
<script src="./SummaryView.ts"></script>
